export const GET_ENTRY_FORM_BY_CONTACT = `
  query entryForms(
    $tenant_id: Int!
    $filter: FilterEntryFormInput
  ) {
    entryForms(
      tenant_id: $tenant_id
      filter: $filter
    ) {
      __typename
      ... on EntryForm {
        id
        contact_id
        referred_by
        referred_by_free_text
        referrer {
          id
          firstname
          lastname
        }
        date_from
      }
      ... on ResultError {
        status_code
        message
        message_translation_key
      }
    }
  }
`;

export const GET_ENTRY_FORM_PDF_URL = `
  query getEntryFormPdfUrl($id: Int!, $tenant_id: Int!) {
    getEntryFormPdfUrl(id: $id, tenant_id: $tenant_id) {
      url
    }
  }
`;
